import React, { useState, useEffect } from 'react';
import client from './api/client';
import PageHeader from './components/PageHeader';
import RegionIskVolumeSection from './components/RegionIskVolumeSection';

// Region ISK volume for the user's seeding destination regions, the only ones with every type's history
function MarketActivityPage() {
  const [regions, setRegions] = useState(null);
  const [regionId, setRegionId] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    client.get('/eve/market/activity/regions/')
      .then(res => {
        setRegions(res.data.regions);
        setRegionId(res.data.regions[0]?.region_id ?? null);
      })
      .catch(err => setError(err.response?.status === 403
        ? 'Log in to see market activity for your seeding regions.'
        : 'Failed to load regions.'));
  }, []);

  return (
    <div className="page">
      <PageHeader title="Market Activity" meta="Your seeding destination regions">
        {regions?.length > 1 && (
          <select value={regionId} onChange={e => setRegionId(Number(e.target.value))} aria-label="Region">
            {regions.map(r => <option key={r.region_id} value={r.region_id}>{r.name}</option>)}
          </select>
        )}
      </PageHeader>
      {error && <div className="error-message">{error}</div>}
      {regions?.length === 0 && (
        <p className="region-overview-empty">
          Add a seeding destination to track its region; only destination regions have every item's market history.
        </p>
      )}
      {regionId && (
        <RegionIskVolumeSection
          key={regionId}
          path={`/eve/market/activity/isk-volume/?region_id=${regionId}`}
          title={`${regions.find(r => r.region_id === regionId).name} ISK volume`}
          defaultCollapsed={false}
        />
      )}
    </div>
  );
}

export default MarketActivityPage;
